import { useContext } from 'react'
import { useIntl } from 'react-intl'

import FloatingActionButton from 'LuxKit/Button/FloatingActionButton'
import LineArrowBreakIcon from 'LuxKit/Icons/line/LineArrowBreakIcon'
import LineCompressLinesIcon from 'LuxKit/Icons/line/LineCompressLinesIcon'
import { ViewModeContext } from 'tripPlanner/contexts/ViewModeContext'

function FloatingViewModeToggle() {
  const intl = useIntl()
  const viewModeContext = useContext(ViewModeContext)

  const compactLabel = intl.formatMessage({
    id: '7s3P4GKrYXazrWb31KDn',
    defaultMessage: 'Compact',
    description: 'Toggle button label to switch to compact view mode in trip planner',
  })
  const detailLabel = intl.formatMessage({
    id: 'wnGxxKeaMUyd6u1Zu3Tk',
    defaultMessage: 'Detail',
    description: 'Toggle button label to switch to detail view mode in trip planner',
  })

  return (
    <FloatingActionButton
      variant="ghost"
      startIcon={
        viewModeContext.viewMode === 'detail' ? (
          <LineCompressLinesIcon />
        ) : (
          <LineArrowBreakIcon />
        )
      }
      onClick={viewModeContext.toggleViewMode}
    >
      {viewModeContext.viewMode === 'detail' ? compactLabel : detailLabel}
    </FloatingActionButton>
  )
}

export default FloatingViewModeToggle
